/** the cube has to be held in winning position for this period [seconds] */
export const TIME_BEFORE_WIN = 2

/** distance between current and winning vectors in the game */
export const DEFAULT_ALLOWED_ERROR = 2
